import React from 'react';
import classNames from 'classnames';

import { IMessage } from '@sv-support-sdk/shared-types/src/common/tickets';
import { createLinksWithAttachments } from '@sv-support-sdk/utils/src/helpers/message';
import sanitizeContent from '@sv-support-sdk/utils/src/helpers/sanitizeContent';
import toLocaleTime from '@sv-support-sdk/utils/src/helpers/toLocaleTime';
import List from '@sv-support-sdk/ui-components/src/components/Lists/List';

import Comment from '../../../components/Panels/Comment';
import DocumentTag from '../../../components/Controls/DocumentTag';

import useMobileDetect from '../../../hooks/useMobileDetect';

import css from '../style.module.scss';

interface IProps {
  message: IMessage;
}

const Message = ({ message }: IProps) => {
  const isMobile = useMobileDetect();

  const authorName = message.author.name;
  const authorEmail = message.author.email;
  const authorAvatar = message.author.avatar;

  const avatar = authorAvatar
    ? { img: { src: authorAvatar } }
    : { icon: 'colored--28--image-document' };

  return (
    <>
      <Comment
        className="indent-md-top"
        authorName={authorName}
        noLeftIndent={isMobile}
        authorAvatar={avatar}
        createdAt={toLocaleTime(message.createdAt)}
        authorEmail={authorEmail}
        htmlMessage={{
          __html: createLinksWithAttachments(
            sanitizeContent(message.message).__html,
            message.attachments,
          ),
        }}
      />
      {message.attachments?.length ? (
        <div
          className={classNames(css.message__attachments, {
            [css.isMobile]: isMobile,
          })}
        >
          <List gap="16" direction={isMobile ? undefined : 'row'} isWrapped={!isMobile}>
            {message.attachments?.map(({ name, id: attachmentId, url, extension }) => {
              return <DocumentTag url={url} key={attachmentId} text={name} extension={extension} />;
            })}
          </List>
        </div>
      ) : null}
    </>
  );
};

export default Message;
